const IS_MAC =
  (typeof navigator !== 'undefined' && navigator.userAgent.includes('Macintosh')) || false;

const KEY_DESCRIPTIONS: Record<string, string | undefined> = {
  mod: IS_MAC ? '⌘' : 'Ctrl',
  shift: 'Shift',
  ctrl: IS_MAC ? '⌃' : 'Ctrl',
  alt: IS_MAC ? '⌥' : 'Alt',
  option: IS_MAC ? '⌥' : 'Alt',
  meta: IS_MAC ? '⌘' : 'Win',
  command: IS_MAC ? '⌘' : 'Win',
  backspace: 'Backspace',
  tab: 'Tab',
  enter: 'Enter',
  return: 'Return',
  capslock: 'Capslock',
  esc: 'Esc',
  escape: 'Escape',
  space: 'Space',
  pageup: 'PgUp',
  pagedown: 'PgDown',
  end: 'End',
  home: 'Home',
  left: '←',
  up: '↑',
  right: '→',
  down: '↓',
  ins: 'Insert',
  del: 'Delete',
  plus: '+',
};

export interface ShortcutKeyParts {
  modifiers: string[];
  key: string;
}

/** Split a shortcut such as `mod+/` into the labels shown in the help dialog. */
export function formatShortcutKeys(shortcut: string | string[]): ShortcutKeyParts {
  const shortcutToShow = Array.isArray(shortcut) ? shortcut[0] : shortcut;
  const keys = shortcutToShow.split('+').map((part) => KEY_DESCRIPTIONS[part] ?? part);
  const modifiers = keys.slice(0, -1);
  const rawKey = keys[keys.length - 1] ?? '';
  const key =
    shortcutToShow.includes('shift') && rawKey.length === 1 ? rawKey.toUpperCase() : rawKey;

  return { modifiers, key };
}
